import axios from 'axios';

// Créer une instance axios avec l'URL de base
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

// Ajouter un intercepteur pour toutes les requêtes
api.interceptors.request.use(
  config => {
    // Récupérer l'accessToken depuis localStorage
    const accessToken = localStorage.getItem('accessToken');

    // Si l'accessToken existe, l'ajouter à l'en-tête d'autorisation
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse pour gérer les erreurs globalement
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Gérer les erreurs communes (401, 403, etc.)
    if (error.response && error.response.status === 401) {
      // Rediriger vers la page de connexion ou rafraîchir le token
      console.error('Session expirée. Veuillez vous reconnecter.');
      // localStorage.removeItem('accessToken');
      // window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
